import AgreementRepository from '../../../repositories/AgreementRepository';
import ExplosivePrecursorFormValidation from './ExplosivePrecursorFormValidation';
import ExplosivePrecursorReview from './ExplosivePrecursorReview';
import RecieverForm from '../shared/RecieverForm';
import BrowserSettings from '../../../helpers/BrowserSettings';
/**
 * Explosive precursors Agreement form
 */
export default class ExplosivePrecursorForm {
    /**
     * Init
     */
    constructor() {
        // Prevents class being used outside of project scope to avoid errors
        if (document.getElementsByClassName('explosivePrecursors-agreement').length < 1) {
            return;
        }

        new ExplosivePrecursorReview();
        new RecieverForm('explosives');

        this.submitButton = document.querySelector('#submitExplosivePrecursorData');

        // Form Validation
        this.validation = new ExplosivePrecursorFormValidation();

        // Repository
        this.repository = new AgreementRepository('explosives');

        // Internal use - Reciever customer.
        // Fetch Reciever data & populate customer drop down
        this.receivers();

        // EventListerners
        this.initEventListeners();
    }

    /**
     * Init EventListnerners in form
     * @return void
     */
    initEventListeners() {
        this.eventListenerProducts();
        this.eventListenerDisabledFields();
        this.eventListenerFormItems({ queryElement: '.companyType', trigger: 'click' });
        this.eventListenerFormItems({ queryElement: '.explosiveForm', trigger: 'change' });

        // Save data to Api and trigger signing
        this.submitButton.addEventListener('click', this.submitExplosivePrecursorData);
    }

    /**
     * Submit explosive precursors
     * @return void
     */
    submitExplosivePrecursorData = () => {
        if (this.popupsIsBlocked()) {
            return;
        }

        this.repository.commonPostAgreementDataAsync(
            '/api/e-signing/agreements/explosive-precursors',
            'explosivePrecursors'
        );
    };

    /**
     * EventListener - form
     * EventListener form fields
     * @params {*}
     * @return void
     */
    eventListenerFormItems(params) {
        for (let item of document.querySelectorAll(`${params.queryElement}`)) {
            item.addEventListener(
                `${params.trigger}`,
                () => {
                    this.prepareValidation();
                },
                false
            );
        }
    }

    /**
     * EventListener - If product is selected, unlock the form
     * EventListener product
     * @return void
     */
    eventListenerProducts() {
        for (let item of document.querySelectorAll('.lm__tick .explosivesProduct')) {
            item.addEventListener(
                'click',
                () => {
                    for (let xitem of document.querySelectorAll('.explosiveForm')) {
                        xitem.classList.add('disabled');
                    }

                    if (document.querySelectorAll('.explosivesProduct:checked').length > 0) {
                        for (let xitem of document.querySelectorAll('.explosiveForm')) {
                            xitem.classList.remove('disabled');
                        }

                        document.querySelector('#errorProduct').classList.add('hidden');
                        this.prepareValidation();
                    } else {
                        document.querySelector('#Step1Next').classList.add('disabled');
                    }
                },
                false
            );
        }
    }

    /**
     * EventListener - If no product is is selected
     * Show message if user click on form
     * Product error error message ()
     * @return void
     */
    eventListenerDisabledFields() {
        for (let item of document.querySelectorAll('.explosivesFormElements')) {
            item.addEventListener(
                'click',
                () => {
                    for (let item of document.querySelectorAll('.explosiveForm')) {
                        if (item.classList.contains('disabled')) {
                            document.querySelector('#errorProduct').classList.remove('hidden');
                        }
                    }
                },
                false
            );
        }
    }

    /**
     * prepareValidation
     * If form is valid Enable or diable Next step button
     * @return void
     */
    prepareValidation() {
        let priority = [];
        document.querySelector('#Step1Next').classList.add('disabled');

        for (let prioItem of document.querySelectorAll('.validationPrio')) {
            if (prioItem.checked) {
                if (prioItem.classList.contains('explosivesProduct')) {
                    priority.push('explosivesProduct');
                }

                if (prioItem.classList.contains('companyType')) {
                    priority.push('companyType');
                }
            }
        }

        if (priority.includes('explosivesProduct') && priority.includes('companyType')) {
            this.validation.checkForm('form');
        }
    }

    /**
     * Internal site - Logic for Reciever form
     * @return void
     */
    receivers() {
        if (document.querySelector('#isInternal').value === 'true') {
            this.repository.fetchRecieverDataAsync(
                '/api/e-signing/get-receivers-for-digital-signing'
            );
        }
    }

    /**
     * @description Check if the browser alow popups
     */
    popupsIsBlocked() {
        const browser = new BrowserSettings();
        const isBlocked = browser.checkPopUpBlocker();

        if (isBlocked) {
            document.querySelector('#step1View').classList.add('hidden');
            document.querySelector('#step4View').classList.remove('hidden');
            return true;
        } else {
            return false;
        }
    }
}
